import React from 'react';
import { translateRelation } from 'components/EnrollmentV2/util/translation';

const ReviewEmergencyContact = ({ state }) => {
    return (
        <div className="row">
            <div className="col-md-5">
                <ul>
                    <li>
                        Last Name:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['emergencyLastName']}
                        </strong>
                    </li>
                    <li>
                        First Name:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['emergencyFirstName']}
                        </strong>
                    </li>
                    <li>
                        Phone Number:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['emergencyPhone']}
                        </strong>
                    </li>
                </ul>
            </div>
            <div className="col-md-5">
                <ul>
                    <li>
                        Email:{' '}
                        <strong>
                            {state?.enrollment.page4.sub2['emergencyEmail']}
                        </strong>
                    </li>
                    <li>
                        Relationship to Enrollee:{' '}
                        <strong>
                            {translateRelation(
                                state?.enrollment.page4.sub2[
                                    'emergencyRelationship'
                                ]
                            )}
                        </strong>
                    </li>
                </ul>
            </div>
        </div>
    );
};

export default ReviewEmergencyContact;
